module.exports = __webpack_public_path__ + "img/nft-06.a866d54a.jpg";